// Events
export const customResizeEvent = 'windowResize';
export const updateTournamentsListEvent = 'updateTournamentsList';
export const dataLoadStartEvent = 'dataLoadStart';
export const dataLoadEndEvent = 'dataLoadEnd';
export const dataToLoadMoreEvent = 'dataToLoadMoreEvent';
export const lazyContentLoaded = 'lazy-content-loaded';
export const seeMoreClickEvent = 'seeMoreClickEvent';
export const updateFavoritesListEvent = 'updateFavoritesList';
export const updateDeletedStarEvent = 'updateDeletedStar';
export const updateDeletedStarHeaderEvent = 'updateDeletedStarHeader';
export const updateAddedStarEvent = 'updateAddedStar';
export const updateAddedStarHeaderEvent = 'updateAddedStarHeader';
export const dataLoadFavoritesStartEvent = 'dataLoadFavoritesStart';
export const dataLoadFavoritesEndEvent = 'dataLoadFavoritesEnd';
export const mainHeaderClass = '.tc-header';

// Devices
export const devices = {
  xsmall: {
    size: 540,
    name: 'mobileDevice',
  },
  small: {
    size: 768,
    name: 'smallDevice',
  },
  medium: {
    size: 1024,
    name: 'mediumDevice',
  },
  large: {
    size: 1200,
    name: 'largeDevice',
  },
  xlarge: {
    name: 'xlargeDevice',
  },
};

// Style Classes
export const activeClass = '.active';
export const activeClassName = 'active';
export const dashedActiveClassName = '-active';
export const dashedSortingDeshClassName = '-desc';
export const hiddenClass = '.-hidden';
export const hiddenClassName = '-hidden';
export const winClassName = '-win';
export const showClass = '.-show';
export const showClassName = '-show';
export const disabledClassName = 'disabled';

// Player Status
export const homePlayerStatus = 'home';
export const awayPlayerStatus = 'away';

// Vocabulary fields
export const winnerVocKey = 'winner';
export const serviceVocKey = 'service';

// Loader  Style Classes
export const loaderClass = '.spinner-container';
export const loaderClassName = 'spinner-container';
export const favoriteLoaderClass = '.favorite-spinner-container';

// Calendar Carousel
// Style Classes
export const carouselContainerClass = '.swiper-container';
export const carouselWrapperClass = '.swiper-wrapper';
export const carouselSlideItemClass = '.tc-calendar__card';
export const carouselSlideItemClassName = 'tc-calendar__card';
export const carouselNextClass = '.swiper-button-next';
export const carouselNextClassName = 'swiper-button-next';
export const carouselPrevClass = '.swiper-button-prev';
export const carouselPrevClassName = 'swiper-button-prev';
export const calendarClass = '.tc-calendar';
export const calendarCardClass = '.tc-calendar__item';
export const calendarCardClassName = 'tc-calendar__item';
export const fewItemsClassName = 'few-items';

// Hooks
export const calendarCarouselHook = '[js-calendar-carousel]';
export const calendarCardHook = '[js-calendar-item]';
export const calendarMonthHook = '[js-tournaments-section-title]';
export const calendarDataType = 'data-type';
export const calendarFullDateAttr = 'data-full-date';
export const calendarIsoDateAttr = 'data-iso-date';
export const calendarDateTimeAttr = 'datetime';
export const calendarDateMonthAttr = 'data-month';
export const calendarDataIndexAttr = 'data-index';
export const calendarDataSeason = 'data-season';

// Calendar Color Bar Hooks
export const colorBarClass = '.fo-carousel__color-bar';
export const calendarColorBarHook = '[js-color-bar]';
export const calendarColorBarItemHook = '[js-color-bar-item]';
// Local Time
export const localTimeHook = '[js-local-time]';
// Match Card Live Update
export const matchCardLiveHook = '[js-match-live-update]';
export const matchCardLiveStartTimeAttr = 'data-start-time';
export const matchCardMatchStatusAttr = 'data-match-status';
export const matchCardMatchIdAttr = 'id';
export const matchCardMatchSlugAttr = 'data-match-slug';
export const matchCardTournamentSlugAttr = 'data-tournament-slug';

export const matchCardLiveClassName = '-live';
export const matchCardLiveStatus = 'live';
export const matchCardPreMatchStatus = 'prematch';
export const matchCardNotStartedStatus = 'notstarted';
export const matchCardAboutToStartStatus = 'matchabouttostart';
export const matchCardDelayedStatus = 'delayed';
export const matchCardPostPonedStatus = 'postponed';
export const matchCardInterruptedStatus = 'interrupted';

export const liveMatchVoc = window.liveMatchVocabulary || {};
export const matchCardLiveUpdateApiBasePath = window.matchLiveUpdateUrl;
export const matchCardLiveUpdatePollingTime = window.matchliveUpdatePollingTime;
export const matchCardLiveUpdateCountDown = window.matchLiveUpdateCountDown;
export const minToMillisConvertSeed = 60000;
export const secsToMillisConvertSeed = 1000;

// Match Card Buttons
export const TennisChannelVideoButtonHook = '[js-tennis-channel-video-button]';
export const TennisChannelVideoPlusButtonHook = '[js-tennis-channel-video-plus-button]';
export const MatchReplayVideoButtonHook = '[js-match-replay-video-button]';

// Match Detail Live Update
export const matchCardDetailStatusHook = '[js-match-card-status]';
export const matchCardDetailScoreContainerHook = '[js-match-card-score-container]';
export const matchCardDetailScoreHook = '[js-match-card-score]';
export const matchCardDetailStatisticsHook = '[js-match-card-stats]';
export const matchCardDetailHomePlayerHook = '[js-match-card-home-player]';
export const matchCardDetailAwayPlayerHook = '[js-match-card-away-player]';
export const matchCardDetailPlayerServiceIconHook = '[js-match-card-player-service-icon]';
export const matchCardDetailPlayerServiceTextHook = '[js-match-card-player-service-text]';
export const matchCardDetailPlayerWinnerIconHook = '[js-match-card-player-winner-icon]';
export const matchCardDetailPlayerWinnerTextHook = '[js-match-card-player-winner-text]';

export const matchCardDetailButtonsHook = '[js-match-card-buttons]';
export const matchCardDetailPredictionsHook = '[js-match-card-predictions]';
export const matchCardDetailStartTimeHook = '[js-match-card-start-time]';

// Tournaments List
// Hooks
export const tournamentsListHook = '[js-tournaments-list]';
export const tournamentsListDataHook = '[js-tournaments-list-data]';
export const tournamentsListSelector = '#tournament-list';
export const tournamentsMonth = 'data-month';
export const tournamentslistLiveScrollItemHook = 'live-scroll-item';
export const tournamentslistLiveScrollItemClass = 'scroll-tournaments-list';

// Style Classes
export const tournamentslistfilterClass = '.tc-tournaments__filters-item';
export const tournamentslistClass = '.tc-tournaments__list-item';
export const tournamentsFilterLevels = 'data-levels';
export const tournamentsFilterCategories = 'data-categories';
export const tournamentsErrorMessageClass = '.tc-tournaments__error-message';
export const tournamentsErrorMessageClassName = 'tc-tournaments__error-message';
export const tournamentsSectionTitleClass = '.tc-tournaments__section-title';
export const tournamentslistCardStatusClass = '.fm-card__status';
export const tournamentslistCardHeaderClass = '.fm-card__header';
export const tournamentslistCardDatesClass = '.fa-dates';
export const tournamentslistCardDatesItemClass = '.fa-dates__item';
export const tournamentslistCardTitleClass = '.fa-text__title';
export const tournamentslistCardStatusCancelledClass = '.fm-card__status-cancelled'; 

// Status
export const tournamentslistStatusLiveClassName = '-live';
export const tournamentslistStatusCancelled = 'cancelled';

export const tournamentslistStatus = {
  live: "live",
  notStarted: "not-started",
  cancelled: "cancelled",
  result: "result"
}


// Tournament Header
// Hooks

export const tournamentHeadersHook = '[js-tournament-header]';

// Tournament Matches List(Order Of Play)
// Hooks
export const tournamentMatchesListHook = '[js-tournament-matches-list]';
export const tournamentMatchesListDataHook = '[js-tournament-matches-list-data]';

// Tournament Scores
// Hooks
export const tournamentScoresHook = '[js-tournament-scores]';
export const tournamentScoresDataHook = '[js-tournament-scores-data]';
export const tournamentScoresFilterEventHook = '[js-scores-filter-event]';
export const tournamentScoresFilterYearHook = '[js-scores-filter-year]';

export const tournamentScoresClass = '.js-tournament-scores';
export const tournamentScoresDataId = '#js-tournament-scores-data';
export const tournamentScoresFilterEventId = '#js-scores-filter-event';
export const tournamentScoresFilterYearId = '#js-scores-filter-year';
export const tournamentScoresFilterYearClass = ".tc-seasons-selector";
export const tournamentScoresFilterYearIdDesktop = '#js-scores-filter-year-desktop';
export const tournamentScoresFilterCompletedId = '#js-scores-filter-completed';
export const tournamentScoresFilterRoundsId = '#js-scores-filter-rounds';
export const tournamentScoresFilterRoundsJumpTo = '#js-scores-filter-rounds-jump-to';
export const tournamentScoresFilterNoRounds = '#js-scores-filter-no-rounds';
export const tournamentScoresFilterRoundsReplaceId = '#js-scores-filter-rounds-replace';
export const tournamentScoresFilterRoundsClass = '.js-scores-filter-rounds';

export const tournamentScoresRoundTitleClass = '.round-title';

export const advBlockNameClass = '.d3-o-adv-block';
export const tournamentScoresAdValue = 'Ad';

export const tournamentScoresFilterBtn = '.item-container__btn';
export const tournamentScoresFilterStatusBtn = '.item-container__status-item';
export const tournamentScoresFilterEventBtn = '.item-container__event';

// Player's tournaments
export const playerTournamentsHook = '[js-player-tournaments]';
export const seeMoreBtnsHook = '[js-player-tournaments-see-more]';
export const seeLessBtnsHook = '[js-player-tournaments-see-less]';
export const cardTagHook = '[js-player-tournaments-card]';
export const matchesTagHook = '[js-player-tournaments-matches]';
export const selectedClassName = 'selected';

// Month Names
export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const compareDateFormat = 'YYYY-MM-DD';
export const compareMonthDayFormat = 'M/D';

// Utils
export const arrayDelimiter = '|';
export const grandSlamSeed = 'grand';

export const rankingsFilter = {
  category: {
    name: 'category',
    atp: 'atp',
    wta: 'wta',
  },
  teamSize: {
    name: 'team-size',
    singles: 'singles',
    doubles: 'doubles',
  },
  type: {
    name: 'type',
    rankings: 'rankings',
    race: 'race',
  },
};

export const rankingsSort = {
  name: 'name',
  lastName: 'lastname',
  ranking: 'ranking',
  change: 'change',
  nationality: 'nationality',
};

export const dashActiveClass = '-active';

export const animationSpeed = 700;

// Search
export const searchContainerHook = '[js-search]';
export const searchHeadClass = '.fo-search__head';
export const searchButtonClass = '.fo-search-btn';
export const searchOpenButtonHook = '[js-search-open]';
export const searchCloseButtonHook = '[js-menu-close]';

export const searchActiveToggle = '-is-active';
export const searchOpenToggle = '-search-is-open';

// Top ADV banner
export const topAdvBannerId = '#jpmasthead';

// Login
export const LoginError = {
  EmailNotVerified: 'email-not-verified',
};

export const UserData = {
  Namespace: 'https://www.tennis.com/',
};

export const FavoritesPage = {
  PagePath: '/my-account/favorites/',
  PromoPagePath: '/my-account/library/favorites/promo',
  NewsListPagePath: '/my-account/library/favorites/',
};

// Tracking
export const trackingApiUrl = '/api/v1/tracking/';

// User Account

export const modalCloseClass = '.tc-modal-close';
export const failedDeleteAccountModalClass = '.failed-delete-account-modal';
export const successDeleteAccountModalClass = '.success-delete-account-modal';

export const addFavoriteButtonClass = '.favorite-add';
export const removeFavoriteButtonClass = '.favorite-remove';

export const favoriteTooltipClass = '.tooltip__content';

export const maxFavoriteModalClass = '.maxFavoritesModal';
export const closeMaxFavoriteModalClass = '.close-max-favorites-modal';
export const loginModalClass = '.loginModal';
export const closeLoginModalClass = '.close-login-modal';
export const actionLoginClass = '.action-login';
export const actionCreateAccountClass = '.action-create-account';

export const userAccountFavoritesListClass = '.tc-user-account-favorites-list';

export const playersRankingsContainerClass = '.tc-players-rankings__grid';
export const playersRankingsSortingClass = '.tc-players-rankings__sorting';
export const playersRankingsSortingItemClass = '.tc-players-rankings__sorting-item';
export const playersRankingsFiltersItemClass = '.tc-players-rankings__filters-item';
export const playersRankingsHook = '[js-players-rankings]';
export const nameInputClass = '.tc-name-input';
export const playersRankingsPlayersItemNameClass = '.tc-players-rankings__players-item--name';
export const playersRankingsPlayersItemLastNameClass =
  '.tc-players-rankings__players-item--last-name';

export const playersRankingsPlayersItemCountryClass = '.tc-players-rankings__players-item--country';
export const playersRankingsPlayersItemRankingClass = '.tc-players-rankings__players-item--ranking';
export const playersRankingsPlayersItemChangeClass = '.tc-players-rankings__players-item--change';
export const playersRankingsCtaClass = '.tc-players-rankings__cta';
export const playersRankingsPlayersClass = '.tc-players-rankings__players';
export const playersRankingsSortingItemRankingClass = '.tc-players-rankings__sorting-item--ranking';
export const playersRankingsNotFoundSectionClass = '.oc-c-search-results';
export const sortDirectionDesc = 'desc';
export const sortDirectionAsc = 'asc';
export const favoriteSearchButtonClass = '.tc-favorite-search-button';
export const favoritesUserSpinnerHook = '[js-user-favs-spinner]';
export const userDataSpinnerHook = '[js-user-data-spinner]';

export const maxFavorites = 10;

export const playerIdAttribute = 'data-id';

export const emptyChampionsClass = '.empty-champions';
export const emptyChampionsMessageClassName = 'empty-message';
export const emptyChampionsMessageAttribute = 'no-info-message';

export const favoritesNewsSpinnerHook = '[js-favs-news-spinner]';
export const favoritesNewsContainerHook = '[js-favs-news-container]';

export const carouselHook = '[js-carousel]';
export const buttonClass = '.fa-button';
export const promoClass = '.oc-o-promo-card';

export const promoUrlAttr = 'data-promo-url';
export const newsListUrlAttr = 'data-news-list-url';

// Video
export const videoDetailMainHook = '[js-video-details-main]';
export const videoNotAvailableErrorMessageAttr = 'not-available-error-message';
export const videoNotAvailableClassName = 'not-available';
export const videoErrorMessageClassName = 'error-message';
export const videoErrorMessageClass = '.error-message';
export const videoPlayerIframeClass = '.tc-video-player-iframe';

export const videoPlayerStandardClass = '.tc-video-player-standard';
export const videoContainerClass = '.video-container';
export const videoIdAttr = 'video-id';
export const videoItemIdPrefix = '#video-player-content-';

export const justifyCenterClassName = 'justify-center';

// Formatted number
export const localNumberData = 'raw-number';

export const enterKeyCode = 13;
export const enterKeyValue = 'Enter';

// Play Game
export const playGamesLinkHook = '[js-play-games-link]';
export const playGamesLinkModalClass = '.play-games-link-modal';

// Routes
export const Routes = {
  Tournaments: 'tournaments',
};
